import {Alert, useOpenModal} from '@/components/Modal/index.mjs'

const domParser = new DOMParser()

// 处理 HTML 实体和 <br>
const parseHtml = s => {
    s = s.replace(/<br\s*\/?>/g, '\n')
    const doc = domParser.parseFromString(s, "text/html")
    return doc.documentElement.textContent
}

const contentWithoutThink = message => message.content.replace(
    /^<think>.*<\/think>\n*/s, ''
)

export const useJsonFromMessage = () => {
    const openModal = useOpenModal()

    return message => {
        try {
            const json = contentWithoutThink(message).replace(
                /^.*?```json\n(.+?)```.*$/is,
                '$1'
            )

            return JSON.stringify(JSON.parse(json))
        }
        catch (err) {
            const errMsg = '未找到可导入的数据'
            openModal(<Alert type="error">{errMsg}</Alert>)
            throw new Error(errMsg)
        }
    }
}

const extractJsonTables = text => [...text.matchAll(/```json\n(.+?)\n```/igs)]
    .map(match => {
        if (! match) {
            return []
        }

        try {
            const data = JSON.parse(match[1])

            if (! Array.isArray(data)) {
                return []
            }

            return data.map(d => {
                if ('object' !== typeof d) {
                    return []
                }

                const {headers, rows} = d

                if (headers || rows) {
                    return [headers, ...rows].map(row => row.map(parseHtml))
                }
                else {
                    return []
                }
            })
        }
        catch (err) {
            console.error(err)
            return []
        }
    })
    .flat()

const rowFromLine = line => line
    // 按 | 分割列并处理转义
    .split(/\s*(?:(?<!\\)|(?<=(?:\\\\)+))\|\s*/)
    // 去除因头尾的 | 产生的空列
    .slice(1, -1)
    .map(parseHtml)

const extractMdTables = text => {
    const lines = text.split('\n')
    const tables = []
    let buf = []
    let hasDivider = false
    let hasError = false

    const flush = () => {
        if (
            // 合法
            hasDivider &&
            // 未出错
            ! hasError &&
            // 有数据
            0 < buf.length
        ) {
            tables.push(buf)
        }
    }

    for (const l of lines) {
        // 有可能是表格的行
        if (/^\|.*\|$/.test(l)) {
            if (hasError) {
                continue
            }

            // 分隔行
            if (/^(\|:?-{3,}:?)+\|$/.test(l)) {
                if (
                    // 之前未处理过分隔行
                    ! hasDivider &&
                    // 缓冲区只有表头
                    1 === buf.length
                ) {
                    hasDivider = true
                }
                else {
                    hasError = true
                }
            }
            else if (
                // 表身
                hasDivider ||
                // 表头
                0 === buf.length
            ) {
                const row = rowFromLine(l)
                buf.push(row)
            }
            else {
                hasError = true
            }
        }
        // 不是表格的行
        else {
            flush()
            buf = []
            hasDivider = false
            hasError = false
        }
    }

    flush()
    return tables
}

export const useTablesFromMessage = () => {
    const openModal = useOpenModal()

    return message => {
        const m = contentWithoutThink(message)

        const tables = [
            ...extractJsonTables(m),
            ...extractMdTables(m),
        ]

        if (0 < tables.length) {
            return tables
        }
        else {
            const errMsg = '未找到可导入的数据'
            openModal(<Alert type="error">{errMsg}</Alert>)
            throw new Error(errMsg)
        }
    }
}
